module.exports = __webpack_public_path__ + "static/media/event-friends-combined-1-iphonex1.0511c74b.png";